import React, { useEffect, useState } from 'react';
import { GoPrimitiveDot } from 'react-icons/go';
import images from './images';
import styles from './ImageSlider.module.scss';
import Arrow from './Arrow';

const style = { transition: 'all 800ms linear' };
const ImageSlider = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const currentImage = images[currentImageIndex];
  const [transformX, setTransformX] = useState('0');
  // Get next image
  const nextImage = () => {
    setCurrentImageIndex(currentImageIndex < images.length - 1 ? currentImageIndex + 1 : 0);
    setTransformX('100px');
  };
  // Get previous image
  const prevImage = () => {
    setCurrentImageIndex(currentImageIndex > 0 ? currentImageIndex - 1 : images.length - 1);
    setTransformX('100%');
  };

  // Get image by index
  const setImage = (index: any) => {
    setCurrentImageIndex(index);
  };

  // To control the auto play animation of carousel
  useEffect(() => {
    const autoPlay = setTimeout(() => {
      nextImage();
    }, 5000);
    return () => clearTimeout(autoPlay);
  }, [currentImageIndex]);
  return (
    <div className={styles.imageSliderContainer}>
      <div
        className={styles.imageSlider}
        style={{
          ...style,
          background: `url(${currentImage}) center /cover no-repeat`,
          transform: `transform(${transformX})`,
        }}
      >
        <Arrow nextImage={nextImage} prevImage={prevImage} />
      </div>
      <div className={styles.navigator}>
        {images.map((_img, index) => (
          <GoPrimitiveDot
            color={index !== currentImageIndex ? '#a0a0a0' : 'black'}
            onClick={() => setImage(index)}
            style={{ cursor: 'pointer' }}
            key={_img}
          />
        ))}
      </div>
    </div>
  );
};
export default ImageSlider;
